import * as React from 'react';

import {Body} from 'shells/typography/body';

import type {GetContextDocuments_contextDocuments as ContextDocument} from 'nutshell-graphql-types';

type Props = {
    document: ContextDocument;
};

export const ContentPreview = (props: Props) => {
    return (
        <div className='flex flex-dir-col pad-24 mb-32 overflow-y-auto justify-center align-center br-16 background-offwhite-dk'>
            <Body
                size='small'
                color='dark'
                maintainLineBreaks={true}
                isItalic={!props.document.content}
                wrapAnywhere={true}
            >
                {props.document.content || 'No content available'}
            </Body>
        </div>
    );
};
